export class ImageSelector extends HTMLElement {

  static get observedAttributes() {
    return ['images'];
  }
  constructor() {
    super();
  }

  close() {
    console.log('CLOSE', {
      parentNode: this.parentNode,
      dialog: this
    })
    return this.parentNode.removeChild(this)
  }

  selectImage(img) {
    const evt = new CustomEvent("onSelection", {
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: img.src
    });
    this.dispatchEvent(evt);
    this.close()
  }

  filterImages(term) {
    const imgs = this.querySelectorAll('.select-image')
    const val = (term || '').toLowerCase()
    if (val) {
      imgs.forEach(node => {
        const title = node.getAttribute('title')
        if (!title.toLowerCase().includes(val)) {
          node.style.display = 'none'
        } else {
          node.style.display = 'inline'
        }
      })
    } else {
      imgs.forEach(node => node.style.display = 'inline')
    }
  }

  handleEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.srcElement.classList.contains('e:close')) {
      return this.close()
    }
    if (event.srcElement.classList.contains('e:selector')) {
      return this.selectImage(event.srcElement)
    }
    if (event.srcElement.classList.contains('on-input')) {
      console.log(event.srcElement.value, event)
      this.filterImages(event.srcElement.value)
    }
  }

  attributeChangedCallback() {
    this.connectedCallback();
  }


  connectedCallback() {
    const images = JSON.parse(this.getAttribute('images'))
    this.innerHTML = `
      <style>
        #image-selector {
          max-width: min(420px, 80vw);
          max-height: min(600px, 70vw);
          position: absolute;
          margin-left: auto;
          margin-right: auto;
          left: 0;
          right: 0;
          text-align: center;
          z-index: 999;
          height: 100%;
        }
        dialog::backdrop {
          background: repeating-linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.4) 1px,
            rgba(0, 0, 0, 0.6) 1px,
            rgba(0, 0, 0, 0.6) 20px
          );
        }
        #image-selector {
          display: block;
          min-width: 280px;
          background: #232323;
          color: white;
          padding: 0;
          position: relative;
          border-radius: var(--border-radius-v2);
          padding: 0 15px 20px 15px;
          box-shadow: 0 0 10px #232323;
          border: 1px solid #232323;
          transform: translateZ(0);
          background: linear-gradient(180deg, #232323, #111);
          overflow: hidden;
        }
        #image-selector .close-dialog {
          font-size: 22px;
          color: white;
          text-shadow: 0 0 2px black;
        }
        #image-selector h2 {
          font-weight: 400;
          font-size: 24px;
          margin-bottom: 0;
        }
        #image-selector .btn-grad {
          border: 1px solid #232323;
        }
        #image-selector .large {
          font-size: 16px;
          padding: 8px 20px;
        }
        button:disabled {
          opacity: .5;
          filter: grayscale(1);
        }
        #image-selector label {
          display: block;
        }
        #image-selector .error {
          color: coral;
        }
        #image-selector .btn-clear {
          border: none;
          background: transparent;
          color: white;
        }
        #image-selector .color-orange {
          color: #fa4804;
        }
        .w50 {
          width: calc(50% - 3px);
        }
        .selector-grid {
          height: inherit;
          padding-bottom: 100px;
        }
        .selector-container {
          padding: 20px 0;
          overflow: auto;
          height: inherit;
        }
        .select-image:hover {
          filter: drop-shadow(0px 0px 2px coral) brightness(1.3);
          cursor: pointer;
        }
      </style>
      <dialog id="image-selector">
        <section class="selector-grid">
          <button class="mapboxgl-popup-close-button click e:close" type="button" aria-label="Close popup" aria-hidden="true">×</button>
          <h1>🗃️ Image Selector</h1>
          <input
            class="search-input on-input"
            type="text"
            class="form-control"
            placeholder="Search... "
            autocomplete="off">
          <div class="selector-container">
            ${images.map(({img, key}) => `
              <img class="select-image click e:selector" title="${key}" width=40 src="${img}"/>
            `).join('')}
          </div>
        </section>
      </dialog>
    `
    this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
    this.querySelectorAll('.on-input').forEach(node => node.addEventListener("input", this))
    const dialog = this.querySelector('#image-selector')
    dialog.showModal()
    dialog.style.width = `${dialog.offsetWidth}px`
    if (dialog) {
      dialog.addEventListener("close", () => this.close());
      dialog.showModal()
    }

  }
}

  window.customElements.define("image-selector", ImageSelector);
